export default (fieldName, code, description) => {
  return {
    description,
    meta: {
      validationErrors: {
        [fieldName]: [{ code, description }],
      },
    },
  };
};



// WEBPACK FOOTER //
// ./src/utils/validations/getErrorObject.js